import { Link } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowRight, LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { FavoriteButton } from "./FavoriteButton";

interface CalculatorCardProps {
  title: string;
  description: string;
  icon: LucideIcon;
  href: string;
  category: "physics" | "chemistry" | "math" | "finance" | "tools" | "general";
}

const categoryColors = {
  physics: "from-primary/20 to-primary/5",
  chemistry: "from-accent/20 to-accent/5",
  math: "from-primary/15 to-accent/10",
  finance: "from-emerald-500/20 to-green-500/10",
  tools: "from-blue-500/20 to-blue-500/10",
  general: "from-purple-500/20 to-purple-500/10",
};

export function CalculatorCard({
  title,
  description,
  icon: Icon,
  href,
  category,
}: CalculatorCardProps) {
  return (
    <div className="group relative">
      <div className="absolute top-3 right-3 z-10">
        <FavoriteButton calculatorPath={href} calculatorName={title} />
      </div>
      <Link to={href}>
        <Card className="h-full transition-all hover:shadow-lg hover:-translate-y-1">
          <CardHeader>
            <div className={cn(
              "w-12 h-12 rounded-lg bg-gradient-to-br flex items-center justify-center mb-4",
              categoryColors[category]
            )}>
              <Icon className="h-6 w-6 text-primary" />
            </div>
            <CardTitle className="flex items-center justify-between pr-8">
              {title}
              <ArrowRight className="h-4 w-4 text-muted-foreground transition-transform group-hover:translate-x-1" />
            </CardTitle>
            <CardDescription>{description}</CardDescription>
          </CardHeader>
        </Card>
      </Link>
    </div>
  );
}
